import { jobLabel } from "@veyso/core";
import type { LanguageView } from "../api.js";

type Step = { label: string; state: "done" | "current" | "todo" };

/** Where a language being made is, as the list of steps the popover shows. */
export function languageSteps(language: Pick<LanguageView, "status" | "step" | "wholeVideo">): Step[] {
  const labels = [
    language.status === "translating" ? "Translating" : "Translated",
    "Voicing the script",
    ...(language.wholeVideo ? ["Redrawing every word on screen"] : []),
    "Finishing",
  ];
  const last = labels.length - 1;
  const current =
    language.status === "translating"
      ? 0
      : language.step === "drawing" && language.wholeVideo
        ? 2
        : language.step === "storing" || language.step === "charging"
          ? last
          : 1;
  return labels.map((label, index) => ({
    label,
    state: index < current ? "done" : index === current ? "current" : "todo",
  }));
}

export function languageStepLabel(language: Pick<LanguageView, "status" | "step">): string {
  return jobLabel(language.status === "translating" ? "translate" : "language_voice", language.step) ?? "Starting";
}
